import React from 'react';

function RecHum () {
    return (
        <div className="espacio">
            <p class="h1 text-center">Recursos Humanos</p>
        <div class="row container-fluid align-items-center espacio">
            <div class="col-sm-6">
                <div class="card text-center border-white">
                <div class="card-body">
                    <h5 class="card-title">Préstamo administrativo</h5>
                    <a target="_blank" href="https://arbal.wilsoftapp.com/qprocess/Apps/Run/7555a5c8-76e9-4650-9512-8dc8e14288e1">
                    <img src="https://res.cloudinary.com/ironhackmigu8/image/upload/c_scale,w_70/v1611106354/ARBAL/SIAR/WhatsApp_Image_2021-01-19_at_7.32.11_PM.jpg" class="img-thumbnail" alt="..."></img>
                    </a>
                    <p class="card-text"></p>
                </div>
                </div>
            </div>
            <div class="col-sm-6">
                <div class="card text-center border-white">
                <div class="card-body">
                    <h5 class="card-title">Anticipo de nómina</h5>
                    <a target="_blank" href="https://arbal.wilsoftapp.com/qprocess/Apps/Run/ec34b079-b2bd-4b92-86fb-c9be585d98b6">
                    <img src="https://res.cloudinary.com/ironhackmigu8/image/upload/c_scale,w_70/v1611106497/ARBAL/SIAR/WhatsApp_Image_2021-01-19_at_7.33.16_PM.jpg" class="img-thumbnail" alt="..."></img>
                    </a>
                    <p class="card-text"></p>
                </div>
                </div>
            </div>
        </div>
        </div>
    )
}

export default RecHum